<template>
  <div class="exjsmind">
    <div ref="jsm" style="width: 100%;"></div>
  </div>
</template>

<script>
import jsMind from "jsmind";
import "jsmind/style/jsmind.css";

export default {
  props: {
    treeData: {
      type: Object
    },
    keyL: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  mounted() {
    // console.log("treeData", this.treeData);
    this.createMindMap();
  },
  watch: {
    keyL(nl, ol) {
      this.createMindMap();
    }
  },
  methods: {
    // 素养发展总览思维导图的渲染
    createMindMap() {
      const options = {
        container: this.$refs.jsm,
        editable: false, // 可选，是否启用编辑
        theme: "primary",
        view: {
          line_width: 2 // 思维导图线条的粗细
          // line_color: this.lineColor, // 思维导图线条的颜色
        },
        shortcut: {
          enable: true // 禁用快捷键
        },
        layout: {
          hspace: 20, // 节点之间的水平间距
          vspace: 10, // 节点之间的垂直间距
          pspace: 13 // 节点与连接线之间的水平间距（用于容纳节点收缩/展开控制器）
        },
        mode: "side" // 显示模式，子节点只分布在根节点右侧
      };

      // 使用 new 关键字创建 jsMind 实例
      const jm = new jsMind(options);
      // console.log('jm',jm);

      // 调用 show 方法显示思维导图
      jm.show({
        meta: {
          name: "jsmind",
          author: "hizzgdev@163.com",
          version: "0.2"
        },
        format: "node_tree",
        data: this.treeData
      });

      let elements = this.$refs.jsm.getElementsByClassName("jsmind-inner")[0];

      let sw = (715 / jm.view.size.w).toFixed(2);

      elements.style.height = `${jm.view.size.h * sw}px`;

      elements.style.width = `${jm.view.size.w * sw}px`;

      jm.view.minZoom = sw;
      jm.view.setZoom(jm.view.minZoom); // 应用最小缩放级别
      jm.view.show(); // 重绘思维导图以应用缩放变化
    }
  }
};
</script>

<style scoped>
.exjsmind >>> jmnode {

  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  /* min-width: 20px; */
  /* max-width: 250px; */
  /* overflow: hidden; */
  letter-spacing: 5px;
  font-size: 12px !important;
  /* flex-wrap: wrap; */
  /* white-space: wrap; */
}
</style>



// WEBPACK FOOTER //
// src/components/pages/components/exjsmind.vue